import { Grid } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { PencilSquare } from "react-bootstrap-icons";
import { usePlaidLink } from "react-plaid-link";
import { useFetch } from "../../features/Fetch/Fetch";
import { useItems } from "../../features/Fetch/Items";

const UpdateLink = (props: any) => {
	let [token, setToken] = useState(null);

	const request = useFetch();
	const items = useItems();
	const accountId = props?.Account?.accountId;

	useEffect(() => {
		let cancelled = false;
		request
			.getRaw(`Settings/CreateLinkToken/true/${accountId}`)
			.then((response) => response.text())
			.then((data: any) => {
				if (cancelled) return;
				setToken(data);
			});
		return () => {
			cancelled = true;
		};
	}, [accountId, request]);

	const onSuccess = useCallback(async (_publicToken: any, _metadata: any) => {
		await items.GetAccountsAsync();
	}, [items]);

	const isOauth = false;

	const config: any = {
		token,
		onSuccess,
	};

	const { open, ready } = usePlaidLink(config);

	useEffect(() => {
		if (!isOauth) return;
		if (!ready) return;
		open();
	}, [isOauth, open, ready]);

	return (
		<Grid item xs={6} md={2}>
			<div className="btn btn-account btn-list text-app" onClick={() => open()}>
				<h3>
					<PencilSquare /> Update
				</h3>
			</div>
		</Grid>
	);
}

export default UpdateLink;